import type { Order } from '@/types';
import { returnStatusPath } from './returnCases';

export interface ReturnAction {
  label: string;
  /** Where the button goes; absent when the return can't be continued from here. */
  path?: string;
  disabled: boolean;
}

/**
 * Return button for a signed-in customer's order — same rules as the original Orders page
 * (pages/customer/OrderHistory.tsx): start or continue in the return chat, go to resolution once
 * approved; after that, track it on the return status page.
 */
export function returnActionFor(order: Pick<Order, 'order_id' | 'returns_active' | 'return_status'>): ReturnAction | undefined {
  if (!order.returns_active) return undefined;
  const raised = order.return_status !== undefined && order.return_status !== null && String(order.return_status) !== 'false';
  const status = raised ? String(order.return_status).toLowerCase() : '';
  const chat = `/customer/return-chat/${order.order_id}`;
  if (!raised) return { label: 'Return', path: chat, disabled: false };
  if (status === 'requested') return { label: 'Continue return', path: chat, disabled: false };
  if (status === 'approved') return { label: 'Proceed to resolution', path: `/customer/orders/${order.order_id}/fix-issue`, disabled: false };
  return { label: 'Track return', path: returnStatusPath(order.order_id), disabled: false };
}
